import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabase';
import '../styles/RegisterPage.css';

const EMPTY_FORM = {
  email: '',
  password: '',
  confirmPassword: '',
  voen: '',
  license_number: '',
  owner_name: '',
  owner_phone: '',
  cafe_name: '',
  business_type: 'cafe',
  cuisine_type: '',
  address: '',
  city: 'Bakı',
  phone: '',
  capacity: '',
  working_hours: '',
  company_name: '',
  legal_name: '',
  owner_position: '',
  owner_id_number: '',
  selected_package: '',
};

const PACKAGES = [
  {
    id: 'STANDARD',
    price: '99 AZN/ay',
    color: '#3b82f6',
    features: [
      'Platforma profili',
      '500 rezervasiya',
      '500 rezervasiya bildirişi',
      '1 filial',
      '10 kampaniya',
      '10 push bildiriş',
      'Normal axtarış sıralaması',
      'Basic analitika paneli',
      'Standart Goo-Points loyallıq',
      'Əməliyyat mobil dəstəyi',
    ],
  },
  {
    id: 'PRO',
    price: '175 AZN/ay',
    color: '#8b5cf6',
    features: [
      'Platforma profili',
      '1000 rezervasiya',
      '1000 rezervasiya bildirişi',
      '5 filial',
      '20 kampaniya',
      '20 push bildiriş',
      'Yüksək axtarış sıralaması',
      'QR Menyu',
      'Detallı analitika paneli',
      'Xüsusi kampaniya hüququ',
      'Əməliyyat mobil dəstəyi',
      'İldə 1 dəfə peşəkar fotosessiya (Menyu)',
      'İldə 1 dəfə peşəkar video/Reels',
      'Tək post/feature sosial media reklamı',
    ],
  },
  {
    id: 'PREMIUM',
    price: '250 AZN/ay',
    color: '#f97316',
    features: [
      'Platforma profili',
      'Limitsiz rezervasiya',
      'Limitsiz rezervasiya bildirişi',
      'Limitsiz filial',
      'Limitsiz kampaniya',
      'Limitsiz push bildiriş',
      'Premium (TOP) axtarış sıralaması',
      'Xüsusi status nişanı ✦',
      'QR Menyu',
      'Tam analitika + Export',
      'Müştəri CRM',
      'VIP Cashback / Xal nisbəti',
      'Xüsusi Kurator dəstəyi',
      'İldə 2 dəfə peşəkar fotosessiya (Tam)',
      'İldə 2 dəfə peşəkar video/Reels',
      'Aylıq sosial media reklam dəstəyi',
    ],
  },
];

const CITIES = [
  // ── Əsas şəhərlər ─────────────────────────────────────────────
  'Bakı',
  'Gəncə',
  'Sumqayıt',
  'Mingəçevir',
  'Naxçıvan',
  'Lənkəran',
  'Şirvan',
  'Şəki',
  'Yevlax',
  'Xankəndi',
  // ── Rayonlar (əlifba sırasıyla) ────────────────────────────────
  'Abşeron',
  'Ağcabədi',
  'Ağdam',
  'Ağdaş',
  'Ağstafa',
  'Ağsu',
  'Astara',
  'Balakən',
  'Bərdə',
  'Beyləqan',
  'Biləsuvar',
  'Cəbrayıl',
  'Cəlilabad',
  'Daşkəsən',
  'Füzuli',
  'Gədəbəy',
  'Goranboy',
  'Göyçay',
  'Göygöl',
  'Hacıqabul',
  'İmişli',
  'İsmayıllı',
  'Kəlbəcər',
  'Kürdəmir',
  'Laçın',
  'Lerik',
  'Masallı',
  'Neftçala',
  'Oğuz',
  'Qax',
  'Qazax',
  'Qəbələ',
  'Qobustan',
  'Quba',
  'Qubadlı',
  'Qusar',
  'Saatlı',
  'Sabirabad',
  'Salyan',
  'Samux',
  'Siyəzən',
  'Şamaxı',
  'Şəmkir',
  'Şuşa',
  'Tartar',
  'Tovuz',
  'Ucar',
  'Xaçmaz',
  'Xızı',
  'Xocavənd',
  'Yardımlı',
  'Zaqatala',
  'Zəngilan',
  'Zərdab',
  // ── Naxçıvan MR rayonları ──────────────────────────────────────
  'Babək',
  'Culfa',
  'Kəngərli',
  'Ordubad',
  'Sədərək',
  'Şahbuz',
  'Şərur',
];

// ── Contract template ────────────────────────────────────────────────────────
function ContractText({ formData, isChain, contractNumber, selectedPackage }) {
  const partnerName = isChain
    ? (formData.company_name || '[Şirkətin adı]')
    : (formData.cafe_name || '[Müəssisənin adı]');
  const voen       = formData.voen || '[VÖEN]';
  const director   = formData.owner_name || '[Direktorun adı]';
  const address    = isChain ? (formData.address || '[Ünvan]') : (formData.address || '[Ünvan]');
  const today      = new Date();
  const day        = today.getDate();
  const monthNames = ['yanvar','fevral','mart','aprel','may','iyun','iyul','avqust','sentyabr','oktyabr','noyabr','dekabr'];
  const monthName  = monthNames[today.getMonth()];
  const year       = today.getFullYear();

  const tdStyle = { border: '1px solid #ccc', padding: '6px 8px', fontSize: 12, verticalAlign: 'top' };
  const thStyle = { ...tdStyle, background: '#f5f5f5', fontWeight: 700, textAlign: 'center' };

  return (
    <div style={{ fontSize: 13, lineHeight: 1.8, color: '#1a1a1a', fontFamily: 'Georgia, serif' }}>

      <p style={{ textAlign: 'center', fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
        RESTORAN XİDMƏTLƏRİNİN RƏQƏMSAL İDARƏEDİLMƏSİ HAQQINDA<br />ƏMƏKDAŞLIQ MÜQAVİLƏSİ
      </p>
      <p style={{ textAlign: 'center', marginBottom: 16, fontSize: 12, color: '#555' }}>
        Müqavilə №: <strong>{contractNumber}</strong> &nbsp;|&nbsp; Bakı şəhəri &nbsp;|&nbsp;
        Tarix: "{day}" {monthName} {year}-ci il
      </p>

      <p><strong>Maddə 1. Müqavilənin Tərəfləri</strong></p>
      <p>1.1. Platforma: <strong>"Eintree Solutions" Məhdud Məsuliyyətli Cəmiyyəti.</strong> VÖEN: 1906672121 | Hüquqi ünvan: Bakı şəhəri, Suraxanı rayonu, Yeni Günəşli qəsəbəsi, "D" yaşayış massivi, ev 11, mənzil 11.</p>
      <p>1.2. Tərəfdaş: <strong>{partnerName}</strong>, VÖEN: <strong>{voen}</strong>, Ünvan: {address}.</p>

      <p><strong>Maddə 2. Müqavilənin Mövzusu</strong></p>
      <p>2.1. Müqavilənin predmeti Platforma tərəfindən Tərəfdaşa məxsus iaşə müəssisəsinin xidmətlərinin "Cafegoo" platforması vasitəsilə rəqəmsal təqdimatı, masa rezervasiyası, öncədən sifariş və loyallıq proqramlarının idarə edilməsidir.</p>

      <p><strong>Maddə 3. Xidmət Haqqı və Seçilmiş Paket</strong></p>
      <p>3.1. Tərəfdaşın seçdiyi xidmət paketinin texniki imkanları bu Müqavilənin ayrılmaz hissəsi olan "Əlavə №1" cədvəlində qeyd edilmişdir. Tərəfdaş aşağıdakı aylıq xidmət haqlarından birini seçmişdir:</p>
      <p>
        {selectedPackage === 'STANDARD' ? '☑' : '☐'} <strong>STANDARD — 99 AZN/ay</strong>
        &nbsp;&nbsp;&nbsp;
        {selectedPackage === 'PRO' ? '☑' : '☐'} <strong>PRO — 175 AZN/ay</strong>
        &nbsp;&nbsp;&nbsp;
        {selectedPackage === 'PREMIUM' ? '☑' : '☐'} <strong>PREMIUM — 250 AZN/ay</strong>
      </p>
      <p>İllik abunə 12 ay öncədən tam ödənildikdə ümumi məbləğə <strong>10% endirim</strong> tətbiq edilir.</p>

      <p><strong>Maddə 4. Loyallıq Proqramının İdarəedilməsi və Müstəsna Hüquqlar</strong></p>
      <p>4.1. <em>Reqlamentləşdirmə Hüququ:</em> "Goo-Points" loyallıq proqramının bütün qaydaları, xalların qazanılma nisbəti, nominalları və xərclənmə şərtləri müstəsna olaraq Platforma tərəfindən müəyyən edilir. Platforma bazar konyunkturuna uyğun olaraq bu qaydaları birtərəfli qaydada dəyişdirmək hüququnu özündə saxlayır.</p>
      <p>4.2. <em>Xalın Xərclənmə Mexanizmi:</em> Xalların hansı məhsul və ya xidmət paketlərinə dəyişdiriləcəyi Platforma tərəfindən təyin edilir. Tərəfdaş Platformanın tətbiq etdiyi standart paketlərin (məsələn: 1500 xal = Kofe+Desert) öz müəssisəsində maneəsiz icra olunmasını təmin etməyə borcludur.</p>
      <p>4.3. <em>İstifadə Limitləri:</em> "Minimum Sifariş Həddi" və ya "İstifadə Saatları" kimi məhdudiyyətlər Platforma tərəfindən müəyyən olunur. Tərəfdaş özbaşına məhdudiyyət qoya bilməz.</p>
      <p>4.4. <em>İmtinaedilməzlik:</em> Tərəfdaş sistem tərəfindən təsdiqlənmiş xal ödənişlərini qəbul etməkdən imtina edə bilməz. Belə hal baş verdikdə, Tərəfdaş müştəriyə dəymiş zərəri kompensasiya etmək öhdəliyi daşıyır.</p>

      <p><strong>Maddə 5. Maliyyə Öhdəlikləri və Gecikmələr</strong></p>
      <p>5.1. <em>Abunə haqqı:</em> Tərəfdaş seçilmiş məbləği hər təqvim ayının ilk 3 (üç) iş günü ərzində Platformanın bank hesabına köçürür.</p>
      <p>5.2. <em>Gecikmə sanksiyası:</em> Ödəniş 3 iş günü gecikdikdə, Platforma 48 saatlıq xəbərdarlıqdan sonra xidmətləri dayandırmaq hüququna malikdir.</p>
      <p>5.3. <em>Qiymət Artımı:</em> Platforma abunə haqqını bazar konyunkturuna uyğun olaraq yeniləmək hüququnu özündə saxlayır (30 gün öncədən yazılı bildirişlə).</p>

      <p><strong>Maddə 6. Depozitlərin İdarə Edilməsi</strong></p>
      <p>6.1. İstifadəçidən alınan 50% depozit məbləği Platformanın tranzit hesabında toplanır və xidmət icra edildikdən sonra 3 (üç) iş günü ərzində Tərəfdaşın bank hesabına transfer edilir.</p>

      <p><strong>Maddə 7. Platformanın Öhdəlikləri</strong></p>
      <p>7.1. Platforma sistemin ay ərzində 99% texniki fasiləsiz işləməsini və nasazlıqların 24 saat ərzində həllini təmin edir.</p>

      <p><strong>Maddə 8. Tərəfdaşın Öhdəlikləri</strong></p>
      <p>8.1. <em>Masa Hazırlığı:</em> Rezervasiya vaxtından etibarən masanın hazırlanması üçün maksimal 15 dəqiqə vaxt ayrılır. Masa hazır olmadıqda sifarişin statusu müvafiq qaydada yenilənməlidir.</p>
      <p>8.2. <em>Masa Doluluq Nisbəti:</em> Tərəfdaş müəssisədəki real masa doluluq faizini Platformanın paneli vasitəsilə real vaxt rejimində yeniləməyə borcludur.</p>
      <p>8.3. <em>Məsuliyyət:</em> Məlumatın yenilənməməsi səbəbindən yaranan müştəri narazılığına görə birbaşa Tərəfdaş məsuliyyət daşıyır.</p>

      <p><strong>Maddə 9. Sifarişin Ləğvi və "No-Show" Siyasəti</strong></p>
      <p>9.1. Müştəri rezervasiyaya 1 saatdan az vaxt qaldıqda gəlməzsə (No-Show), 50% depozit Tərəfdaşın hesabına transfer edilir.</p>
      <p>9.2. Rezervasiya Tərəfdaşın xətası (yer yoxluğu və s.) səbəbindən baş tutmazsa, depozit müştəriyə qaytarılır.</p>

      <p><strong>Maddə 10. Marketinq və Reklam Hüquqları</strong></p>
      <p>10.1. Tərəfdaş öz loqo, menyu və interyer fotolarının Platforma tərəfindən reklam məqsədilə istifadəsinə icazə verir.</p>

      <p><strong>Maddə 11. Qida Təhlükəsizliyi və Məsuliyyət</strong></p>
      <p>11.1. Tərəfdaş AQTA lisenziyasına malik olduğunu bəyan edir. Qidanın keyfiyyəti və sanitar normalara görə birbaşa Tərəfdaş məsuliyyət daşıyır.</p>

      <p><strong>Maddə 12. Xidmət Keyfiyyəti və Sanksiyalar</strong></p>
      <p>12.1. Ciddi şikayətlər daxil olarsa, Platforma xidmətlərin göstərilməsini birtərəfli qaydada müvəqqəti dayandıra bilər.</p>
      <p>12.2. Masa doluluq nisbətinin yanlış göstərilməsi səbəbindən müştərinin qəbul edilmədiyi hər hal üçün Tərəfdaşa rəsmi xəbərdarlıq edilir; hal təkrarlandıqda əməkdaşlığa xitam verilir.</p>

      <p><strong>Maddə 13. Məxfilik və Məlumatların Silinməsi</strong></p>
      <p>13.1. Müqaviləyə xitam verildiyi tarixdən 30 təqvim günü sonra Tərəfdaşa aid bütün fərdi və kommersiya məlumatlar tamamilə silinir.</p>

      <p><strong>Maddə 14. Fors-Major</strong></p>
      <p>14.1. Tərəflərin iradəsindən asılı olmayan fövqəladə hallar zamanı öhdəliklərin icrası dayandırılır.</p>

      <p><strong>Maddə 15. Müqavilənin Müddəti və Avtomatik Uzadılma</strong></p>
      <p>15.1. Müqavilə tərəflərin razılaşdığı 1 illik müddət ərzində qüvvədədir. Tərəflərdən biri müddətin bitməsinə 30 təqvim günü qalmış yazılı etiraz etmədikdə, müqavilə eyni müddət qədər avtomatik olaraq uzadılır.</p>

      <p><strong>Maddə 16. "Pet-Friendly" Müəssisə Statusu</strong></p>
      <p>16.1. <em>Könüllü İştirak:</em> Tərəfdaş öz daxili siyasətinə uyğun olaraq müəyyən zonalarda ev heyvanı ilə gələn müştəriləri qəbul edə bilər.</p>
      <p>16.2. <em>"Cafegoo" Nişanı:</em> Bu siyasəti qəbul edən Tərəfdaşlar tətbiqdə xüsusi "Pet-Friendly" nişanı ilə işarələnir.</p>
      <p>16.3. <em>Məsuliyyətin İstisnası:</em> Müştərinin gətirdiyi heyvanın davranışına görə Platforma heç bir məsuliyyət daşımır.</p>
      <p>16.4. <em>Gigiyena Standartları:</em> Tərəfdaş yerli sanitariya qaydalarına uyğun olaraq heyvanların qəbul şərtlərini müstəqil tənzimləmək hüququna malikdir.</p>

      <p><strong>Maddə 17. Mübahisələrin Həlli</strong></p>
      <p>17.1. Razılıq əldə edilmədiyi təqdirdə, mübahisələr Azərbaycan Respublikasının müvafiq məhkəmələri tərəfindən həll edilir.</p>

      {/* ── İmzalar ── */}
      <div style={{ marginTop: 32, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div>
          <p style={{ fontWeight: 700, marginBottom: 4 }}>Platforma (Eintree Solutions MMC):</p>
          <p>Direktor: R. Mahmudov</p>
          <p style={{ marginTop: 32, borderTop: '1px solid #ccc', paddingTop: 8, color: '#888' }}>İmza _________________</p>
        </div>
        <div>
          <p style={{ fontWeight: 700, marginBottom: 4 }}>Tərəfdaş:</p>
          <p><strong>{partnerName}</strong></p>
          <p>VÖEN: {voen}</p>
          <p>Direktor: {director}</p>
          <p style={{ marginTop: 16, borderTop: '1px solid #ccc', paddingTop: 8, color: '#888' }}>İmza (M.P) _________________</p>
        </div>
      </div>
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
const RegisterPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState('');
  const [isChain, setIsChain]           = useState(null);
  const [currentStep, setCurrentStep]   = useState(0);
  const [licenseFile, setLicenseFile]   = useState(null);
  const [licenseFileName, setLicenseFileName] = useState('');
  const [formData, setFormData]         = useState(EMPTY_FORM);
  const [contractAccepted, setContractAccepted] = useState(false);
  const [contractNumber] = useState(() => {
    const rand = Math.floor(1000 + Math.random() * 9000);
    return `CF-2026-${rand}`;
  });
  // +1 for package step before contract
  const totalSteps = isChain ? 5 : 4;

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowed = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (!allowed.includes(file.type)) { setError('Yalnız PDF, JPG və ya PNG formatı qəbul edilir'); e.target.value = ''; return; }
    if (file.size > 10 * 1024 * 1024) { setError('Fayl ölçüsü 10 MB-dan çox ola bilməz'); e.target.value = ''; return; }
    setError('');
    setLicenseFile(file);
    setLicenseFileName(file.name);
  };

  const chooseChain = (value) => { setIsChain(value); setCurrentStep(1); setError(''); };

  // ── Validators ──────────────────────────────────────────────────────────────
  const validators = {
    singleStep1: () => {
      if (!formData.cafe_name || !formData.address || !formData.phone) { setError('Ad, ünvan və telefon mütləqdir'); return false; }
      return true;
    },
    singleStep2: () => {
      if (!formData.owner_name || !formData.voen || !formData.email) { setError('Ad, VÖEN və email mütləqdir'); return false; }
      if (formData.voen.length !== 10) { setError('VÖEN 10 rəqəmli olmalıdır'); return false; }
      if (!formData.email.includes('@')) { setError('Düzgün email daxil edin'); return false; }
      // TEST: if (!licenseFile) { setError('Lisenziya sənədini yükləyin'); return false; }
      if (!formData.password || formData.password.length < 6) { setError('Şifrə ən azı 6 simvol olmalıdır'); return false; }
      if (formData.password !== formData.confirmPassword) { setError('Şifrələr uyğun gəlmir'); return false; }
      return true;
    },
    chainStep1: () => {
      if (!formData.company_name || !formData.legal_name || !formData.voen) { setError('Şirkət adı, hüquqi adı və VÖEN mütləqdir'); return false; }
      if (formData.voen.length !== 10) { setError('VÖEN 10 rəqəmli olmalıdır'); return false; }
      // TEST: if (!licenseFile) { setError('Lisenziya sənədini yükləyin'); return false; }
      return true;
    },
    chainStep2: () => {
      if (!formData.owner_name || !formData.owner_position || !formData.owner_phone) { setError('Ad, vəzifə və telefon mütləqdir'); return false; }
      return true;
    },
    chainStep3: () => {
      if (!formData.email || !formData.email.includes('@')) { setError('Düzgün email daxil edin'); return false; }
      if (!formData.password || formData.password.length < 6) { setError('Şifrə ən azı 6 simvol olmalıdır'); return false; }
      if (formData.password !== formData.confirmPassword) { setError('Şifrələr uyğun gəlmir'); return false; }
      return true;
    },
    package: () => {
      if (!formData.selected_package) { setError('Xidmət paketi seçin'); return false; }
      return true;
    },
    contract: () => {
      if (!contractAccepted) { setError('Müqaviləni oxuyub qəbul etməlisiniz'); return false; }
      return true;
    },
  };

  const handleNext = () => {
    setError('');
    let valid = false;
    const packageStep = isChain ? 4 : 3;
    if (!isChain) {
      if (currentStep === 1) valid = validators.singleStep1();
      else if (currentStep === 2) valid = validators.singleStep2();
      else if (currentStep === packageStep) valid = validators.package();
    } else {
      if (currentStep === 1) valid = validators.chainStep1();
      else if (currentStep === 2) valid = validators.chainStep2();
      else if (currentStep === 3) valid = validators.chainStep3();
      else if (currentStep === packageStep) valid = validators.package();
    }
    if (valid) setCurrentStep(s => s + 1);
  };

  const handleBack = () => {
    setError('');
    if (currentStep === 1) { setCurrentStep(0); setIsChain(null); }
    else setCurrentStep(s => s - 1);
  };

  // ── Submit ───────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validators.contract()) return;
    setLoading(true);

    try {
      let authUserId = null;
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: { data: { full_name: formData.owner_name, account_type: 'business_manager' } },
      });

      if (authError) {
        const alreadyExists = authError.message?.includes('already registered') || authError.message?.includes('already been registered') || authError.status === 422;
        if (alreadyExists) {
          const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({ email: formData.email, password: formData.password });
          if (signInError) throw new Error('Bu email artıq qeydiyyatdadır. Şifrəniz səhvdirsə login səhifəsindən daxil olun.');
          authUserId = signInData.user?.id || null;
        } else {
          throw authError;
        }
      } else {
        authUserId = authData.user?.id || null;
      }

      // TEST: lisenziya upload söndürülüb
      const licenseDocumentUrl = null;

      await supabase.from('business_applications').delete().eq('email', formData.email);
      await supabase.from('business_applications').delete().eq('voen', formData.voen);

      const record = {
        user_id: authUserId,
        email: formData.email,
        voen: formData.voen,
        license_number: formData.license_number || null,
        license_document_url: licenseDocumentUrl,
        representative_name: formData.owner_name,
        representative_email: formData.email,
        representative_phone: formData.owner_phone || null,
        is_chain: isChain,
        contract_accepted: true,
        contract_accepted_at: new Date().toISOString(),
        contract_number: contractNumber,
        selected_package: formData.selected_package,
        status: 'pending',
      };

      if (!isChain) {
        Object.assign(record, {
          company_name: formData.cafe_name,
          legal_name: formData.cafe_name,
          business_type: formData.business_type,
          cuisine_type: formData.cuisine_type || null,
          address: formData.address,
          city: formData.city,
          phone: formData.phone,
          capacity: formData.capacity ? parseInt(formData.capacity) : null,
          working_hours: formData.working_hours || null,
          representative_position: 'Sahibi',
        });
      } else {
        Object.assign(record, {
          company_name: formData.company_name,
          legal_name: formData.legal_name,
          phone: formData.owner_phone || '',
          address: '',
          city: '',
          business_type: 'chain',
          representative_position: formData.owner_position,
          representative_id_number: formData.owner_id_number || null,
        });
      }

      const { error: appError } = await supabase.from('business_applications').insert([record]);
      if (appError) throw appError;

      await supabase.auth.signOut();
      alert('✅ Müraciət uğurla göndərildi!\n\nTəsdiqdən sonra sisteminizə daxil ola bilərsiniz.\nMüqavilənin islaq imzalı nüsxəsi üçün sizinlə əlaqə saxlayacağıq.');
      navigate('/login');
    } catch (err) {
      console.error('Registration error:', err);
      setError('Xəta baş verdi: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // ── Step labels ──────────────────────────────────────────────────────────────
  const stepLabels = !isChain
    ? ['Kafe', 'Sahibi', 'Paket', 'Müqavilə']
    : ['Hüquqi', 'Sahibi', 'Giriş', 'Paket', 'Müqavilə'];

  const isPackageStep  = currentStep === totalSteps - 1;
  const isContractStep = currentStep === totalSteps;

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <div className="register-container">
      <div className="register-box" style={isContractStep || isPackageStep ? { maxWidth: 720 } : {}}>
        <div className="register-header">
          <h1>☕ Cafegoo</h1>
          <p>Biznes Qeydiyyatı</p>
        </div>

        {/* ── Step 0: Branch selector ─────────────────────────────────────── */}
        {currentStep === 0 && (
          <div className="form-step" style={{ textAlign: 'center' }}>
            <h3 style={{ marginBottom: 8 }}>Kafenizin filialları varmı?</h3>
            <p style={{ fontSize: 13, color: '#888', marginBottom: 28 }}>Qeydiyyat növünü seçin</p>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button type="button" onClick={() => chooseChain(false)} style={{
                flex: 1, minWidth: 140, maxWidth: 200,
                padding: '24px 16px', borderRadius: 14,
                border: '2px solid #E8940A', background: '#FFF7E6', cursor: 'pointer', textAlign: 'center',
              }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>☕</div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a1a', marginBottom: 4 }}>Tək Kafe</div>
                <div style={{ fontSize: 12, color: '#888', lineHeight: 1.5 }}>Bir lokasiyon — tam kafe qeydiyyatı</div>
              </button>
              <button type="button" onClick={() => chooseChain(true)} style={{
                flex: 1, minWidth: 140, maxWidth: 200,
                padding: '24px 16px', borderRadius: 14,
                border: '2px solid #ddd', background: '#fafafa', cursor: 'pointer', textAlign: 'center',
              }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🏢</div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a1a', marginBottom: 4 }}>Filial Şəbəkəsi</div>
                <div style={{ fontSize: 12, color: '#888', lineHeight: 1.5 }}>Bir neçə lokasiyon — hüquqi şəxs qeydiyyatı</div>
              </button>
            </div>
            <div className="register-footer" style={{ marginTop: 28 }}>
              <p>Artıq hesabınız var? <a href="/login">Daxil olun</a></p>
            </div>
          </div>
        )}

        {/* ── Steps 1+ ────────────────────────────────────────────────────── */}
        {currentStep >= 1 && (
          <>
            <div className="progress-steps">
              {stepLabels.map((label, i) => (
                <React.Fragment key={label}>
                  <div className={`step ${currentStep >= i + 1 ? 'active' : ''}`}>
                    <div className="step-number">{i + 1}</div>
                    <span>{label}</span>
                  </div>
                  {i < stepLabels.length - 1 && (
                    <div className={`step-line ${currentStep >= i + 2 ? 'active' : ''}`} />
                  )}
                </React.Fragment>
              ))}
            </div>

            <form onSubmit={handleSubmit} className="register-form">

              {/* ── SINGLE: Step 1 — Cafe Details ─────────────────────────── */}
              {!isChain && currentStep === 1 && (
                <div className="form-step">
                  <h3>Kafe Məlumatları</h3>
                  <div className="form-group">
                    <label>Kafenin Adı *</label>
                    <input type="text" name="cafe_name" value={formData.cafe_name} onChange={handleChange} placeholder="Məs. Blue Cup Café" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Biznes Növü *</label>
                      <select name="business_type" value={formData.business_type} onChange={handleChange}>
                        <option value="cafe">Kafe</option>
                        <option value="restaurant">Restoran</option>
                        <option value="bar">Bar</option>
                        <option value="fast_food">Fast Food</option>
                        <option value="club">Klub</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Mətbəx Növü</label>
                      <input type="text" name="cuisine_type" value={formData.cuisine_type} onChange={handleChange} placeholder="Azərbaycan, İtalyan..." />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Ünvan *</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="28 May küç. 5" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Şəhər *</label>
                      <select name="city" value={formData.city} onChange={handleChange}>
                        {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Telefon *</label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+994501234567" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Tutum (Yer sayı)</label>
                      <input type="number" name="capacity" value={formData.capacity} onChange={handleChange} placeholder="50" min="1" />
                    </div>
                    <div className="form-group">
                      <label>İş Saatları</label>
                      <input type="text" name="working_hours" value={formData.working_hours} onChange={handleChange} placeholder="09:00 – 23:00" />
                    </div>
                  </div>
                </div>
              )}

              {/* ── SINGLE: Step 2 — Owner + Legal + Login ────────────────── */}
              {!isChain && currentStep === 2 && (
                <div className="form-step">
                  <h3>Sahibi və Hüquqi Məlumat</h3>
                  <div className="form-group">
                    <label>Sahibinin Adı Soyadı *</label>
                    <input type="text" name="owner_name" value={formData.owner_name} onChange={handleChange} placeholder="Əli Məmmədov" />
                  </div>
                  <div className="form-group">
                    <label>Sahibinin Telefonu</label>
                    <input type="tel" name="owner_phone" value={formData.owner_phone} onChange={handleChange} placeholder="+994501234567" />
                  </div>
                  <div className="form-group">
                    <label>VÖEN (10 rəqəm) *</label>
                    <input type="text" name="voen" value={formData.voen} onChange={handleChange} placeholder="1234567890" maxLength="10" />
                    <small>Vergi Ödəyicisinin Eyniləşdirmə Nömrəsi</small>
                  </div>
                  <div className="form-group">
                    <label>Lisenziya Nömrəsi</label>
                    <input type="text" name="license_number" value={formData.license_number} onChange={handleChange} placeholder="ABC-123456" />
                  </div>
                  <div className="form-group">
                    <label>Lisenziya / Fəaliyyət İcazəsi <span style={{ color: '#E8940A' }}>*</span>
                      <small style={{ display: 'block', color: '#888', fontWeight: 400, marginTop: 2 }}>PDF, JPG və ya PNG — maks. 10 MB</small>
                    </label>
                    <label className="file-upload-label">
                      <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={handleFileChange} className="file-upload-input" />
                      {licenseFileName ? <span className="file-upload-selected">✅ {licenseFileName}</span> : <span className="file-upload-placeholder">📎 Fayl seçin (PDF / Şəkil)</span>}
                    </label>
                  </div>
                  <div className="divider" />
                  <h4>Giriş Məlumatları</h4>
                  <div className="form-group">
                    <label>Email * <small>(giriş üçün)</small></label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="admin@kafem.az" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Şifrə * <small>(min. 6 simvol)</small></label>
                      <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" />
                    </div>
                    <div className="form-group">
                      <label>Şifrəni Təsdiqlə *</label>
                      <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" />
                    </div>
                  </div>
                </div>
              )}

              {/* ── CHAIN: Step 1 — Legal Info ────────────────────────────── */}
              {isChain && currentStep === 1 && (
                <div className="form-step">
                  <h3>Hüquqi Məlumatlar</h3>
                  <div className="form-group">
                    <label>Şirkətin Adı * <small>(brend adı)</small></label>
                    <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} placeholder="Coffeemania" />
                  </div>
                  <div className="form-group">
                    <label>Hüquqi Adı * <small>(rəsmi qeydiyyat adı)</small></label>
                    <input type="text" name="legal_name" value={formData.legal_name} onChange={handleChange} placeholder="Coffeemania MMC" />
                  </div>
                  <div className="form-group">
                    <label>VÖEN (10 rəqəm) *</label>
                    <input type="text" name="voen" value={formData.voen} onChange={handleChange} placeholder="1234567890" maxLength="10" />
                    <small>Vergi Ödəyicisinin Eyniləşdirmə Nömrəsi</small>
                  </div>
                  <div className="form-group">
                    <label>Lisenziya Nömrəsi</label>
                    <input type="text" name="license_number" value={formData.license_number} onChange={handleChange} placeholder="ABC-123456" />
                  </div>
                  <div className="form-group">
                    <label>Lisenziya / Fəaliyyət İcazəsi <span style={{ color: '#E8940A' }}>*</span>
                      <small style={{ display: 'block', color: '#888', fontWeight: 400, marginTop: 2 }}>PDF, JPG və ya PNG — maks. 10 MB</small>
                    </label>
                    <label className="file-upload-label">
                      <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={handleFileChange} className="file-upload-input" />
                      {licenseFileName ? <span className="file-upload-selected">✅ {licenseFileName}</span> : <span className="file-upload-placeholder">📎 Fayl seçin (PDF / Şəkil)</span>}
                    </label>
                  </div>
                </div>
              )}

              {/* ── CHAIN: Step 2 — Owner Identity ───────────────────────── */}
              {isChain && currentStep === 2 && (
                <div className="form-step">
                  <h3>Sahibin Kimliyi</h3>
                  <div className="form-group">
                    <label>Ad Soyad *</label>
                    <input type="text" name="owner_name" value={formData.owner_name} onChange={handleChange} placeholder="Əli Məmmədov" />
                  </div>
                  <div className="form-group">
                    <label>Vəzifəsi *</label>
                    <input type="text" name="owner_position" value={formData.owner_position} onChange={handleChange} placeholder="Direktor, Təsisçi" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Telefon *</label>
                      <input type="tel" name="owner_phone" value={formData.owner_phone} onChange={handleChange} placeholder="+994501234567" />
                    </div>
                    <div className="form-group">
                      <label>Şəxsiyyət vəsiqəsi №</label>
                      <input type="text" name="owner_id_number" value={formData.owner_id_number} onChange={handleChange} placeholder="AA1234567" />
                    </div>
                  </div>
                </div>
              )}

              {/* ── CHAIN: Step 3 — Login ─────────────────────────────────── */}
              {isChain && currentStep === 3 && (
                <div className="form-step">
                  <h3>Giriş Məlumatları</h3>
                  <p style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
                    Filiallarınızı təsdiqləndikdən sonra əlavə edə bilərsiniz.
                  </p>
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="admin@coffeemania.az" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Şifrə * <small>(min. 6 simvol)</small></label>
                      <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" />
                    </div>
                    <div className="form-group">
                      <label>Şifrəni Təsdiqlə *</label>
                      <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" />
                    </div>
                  </div>
                  <div style={{
                    marginTop: 20, padding: '14px 16px', borderRadius: 10,
                    background: 'rgba(232,148,10,0.08)', border: '1px solid rgba(232,148,10,0.25)',
                    fontSize: 13, color: '#7a5000', lineHeight: 1.6,
                  }}>
                    ℹ️ Filial şəbəkəsi hesabı üçün ilkin ödəniş tələb olunmur. Hər filialı ayrıca əlavə edib aktivləşdirəcəksiniz.
                  </div>
                </div>
              )}

              {/* ── PACKAGE STEP ─────────────────────────────────────────── */}
              {isPackageStep && (
                <div className="form-step">
                  <h3>Xidmət Paketi Seçin</h3>
                  <p style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
                    Seçdiyiniz paket müqavilədə qeyd ediləcək. İstənilən vaxt dəyişdirə bilərsiniz.
                  </p>
                  <div className="package-grid">
                    {PACKAGES.map(pkg => {
                      const selected = formData.selected_package === pkg.id;
                      return (
                        <div
                          key={pkg.id}
                          onClick={() => setFormData(p => ({ ...p, selected_package: pkg.id }))}
                          style={{
                            border: `2px solid ${selected ? pkg.color : '#E2E8F0'}`,
                            borderRadius: 14, padding: '18px 14px', cursor: 'pointer',
                            background: selected ? pkg.color + '10' : '#fff',
                            transition: 'all 0.2s', textAlign: 'center',
                          }}
                        >
                          <div style={{ fontWeight: 800, fontSize: 15, color: pkg.color, marginBottom: 4 }}>
                            {pkg.id}
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 12 }}>
                            {pkg.price}
                          </div>
                          <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                            {pkg.features.map(f => (
                              <li key={f} style={{ fontSize: 12, color: '#555', padding: '3px 0', borderBottom: '1px solid #f0f0f0' }}>
                                ✓ {f}
                              </li>
                            ))}
                          </ul>
                          {selected && (
                            <div style={{ marginTop: 12, fontWeight: 700, color: pkg.color, fontSize: 13 }}>
                              ✅ Seçildi
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <p style={{ fontSize: 12, color: '#888', marginTop: 16, textAlign: 'center' }}>
                    İllik abunə 12 ay öncədən ödənildikdə <strong>10% endirim</strong> tətbiq edilir.
                  </p>
                </div>
              )}

              {/* ── CONTRACT STEP (both paths) ────────────────────────────── */}
              {isContractStep && (
                <div className="form-step">
                  <h3>Əməkdaşlıq Müqaviləsi</h3>
                  <p style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
                    Zəhmət olmasa müqaviləni oxuyun. Online qəbul etdikdən sonra islaq imzalı nüsxəni birgə imzalayacağıq.
                  </p>

                  {/* Scrollable contract */}
                  <div style={{
                    maxHeight: 380,
                    overflowY: 'auto',
                    border: '1.5px solid #E2E8F0',
                    borderRadius: 12,
                    padding: '20px 24px',
                    background: '#FAFAFA',
                    marginBottom: 20,
                  }}>
                    <ContractText formData={formData} isChain={isChain} contractNumber={contractNumber} selectedPackage={formData.selected_package} />
                  </div>

                  {/* Accept checkbox */}
                  <label style={{
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                    cursor: 'pointer', padding: '14px 16px',
                    borderRadius: 12,
                    border: `1.5px solid ${contractAccepted ? '#E8940A' : '#E2E8F0'}`,
                    background: contractAccepted ? '#FFF7E6' : '#fff',
                    transition: 'all 0.2s',
                  }}>
                    <input
                      type="checkbox"
                      checked={contractAccepted}
                      onChange={e => { setContractAccepted(e.target.checked); setError(''); }}
                      style={{ width: 18, height: 18, marginTop: 2, accentColor: '#E8940A', flexShrink: 0, cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
                      Yuxarıdakı <strong>Əməkdaşlıq Müqaviləsini</strong> oxudum, şərtləri başa düşdüm və qəbul edirəm.
                      İslaq imzalı nüsxənin imzalanması üçün Cafegoo komandası mənimlə əlaqə saxlaya bilər.
                    </span>
                  </label>
                </div>
              )}

              {error && <div className="error-message">{error}</div>}

              {/* Navigation */}
              <div className="form-navigation">
                <button type="button" className="back-button" onClick={handleBack}>← Geri</button>
                {!isContractStep ? (
                  <button type="button" className="next-button" onClick={handleNext}>Növbəti →</button>
                ) : (
                  <button type="submit" className="submit-button" disabled={loading || !contractAccepted}>
                    {loading ? 'Göndərilir...' : '✅ Müqaviləni Qəbul Et və Göndər'}
                  </button>
                )}
              </div>
            </form>

            <div className="register-footer">
              <p>Artıq hesabınız var? <a href="/login">Daxil olun</a></p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RegisterPage;
